import { render, staticRenderFns } from "./AdditionalProductDetail.vue?vue&type=template&id=8f0b4d6e&scoped=true"
import script from "./AdditionalProductDetail.vue?vue&type=script&lang=js"
export * from "./AdditionalProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0b4d6e",
  null
  
)

export default component.exports